import React from "react";
import { useParams } from "react-router-dom";
import {
  deleteHostelFacility,
  getHostelFacilities
} from "../../../services/OrganisationServices/hostelManagmentService";
import AddHostelFacilityComponent from "./add-hostel-facilities-form.js";
import MasterTable2 from "../../../views/dashboard/widget/MasterTabe2.js";

const HostelFacilitiesTable = () => {
  const { id } = useParams();

  return (
    <div>
      <MasterTable2
        getList={getHostelFacilities}
        tab1={"Hostel"}
        tab2={"Hostel Facilities"}
        hostelId={id}
        AddForm={AddHostelFacilityComponent}
        actions={{
          edit: true,  
          delete: true,
        }}
        deleteFun={deleteHostelFacility}
        title={"Hostel Facilities"}
        subTitle={"Facility"}
        details={{ _HOSTEL: id }}  
        isAdmin={true} 
      />
    </div>
  );
};

export default HostelFacilitiesTable;